import { FormInstance } from "antd";
import { blockUnblockUser } from "../../../acions/users";
import { useAppDispatch } from "../../../store";
import { useCallback, useState } from "react";

export const useToggleStatus = (
  userId: string | null,
  form: FormInstance,
  isBlock: boolean,
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  reloadData: () => void
) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSubmit = useCallback(
    async (values: any) => {
      try {
        if (userId) {
          setIsLoading(true);
          await Promise.resolve(
            dispatch(
              blockUnblockUser({ userId, reason: values.reason }, isBlock)
            )
          );

          setIsLoading(false);
          setIsModalOpen(false);
          reloadData();
          form.resetFields();
        }
      } catch {
        setIsLoading(false);
        form.resetFields();
      }
    },
    [dispatch, form, isBlock, reloadData, setIsModalOpen, userId]
  );

  return { isLoading, onSubmit };
};
